import './assets/App.scss';

import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from "react-router-dom";

import { Analytics } from "@vercel/analytics/react"
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/Home';
import Layout from './components/layout/Layout';
import Privacy from './components/privacy';

function App() {
    return (
        <HelmetProvider>
        <div className="App">
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#3fb0bb',
                        colorTextSecondary: '#6b7280',
                        colorBgBase: '#ffffff',
                        colorText: '#374151',
                        borderRadius: 10,
                        fontFamily: '"Inter", "Segoe UI", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif',
                    },
                }}
            >
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route index element={<Home />} />
                            <Route path="privacy" element={<Privacy />} />
                            {/* <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} /> */}
                        </Route>
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </BrowserRouter>
            </ConfigProvider>
            <Analytics />
        </div>
        </HelmetProvider>
    );
}

export default App;
